import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 24482 23796"
    {...props}
  >
    <path
      d="M12240 15428c1781 4 3294-1499 3278-3255-16-1736-1499-3211-3244-3228-1787-18-3290 1452-3304 3230-14 1777 1467 3250 3270 3253zm1394-7909c922 664 1764 1269 2665 1917 682-1062 1397-2176 2111-3289 328-511 651-1025 983-1533 480-731 936-820 1635-292 1780 1344 2676 3206 3126 5312 276 1294 275 2590-138 3863-263 816-634 994-1441 681-1710-661-3414-1337-5121-2005-105-41-216-67-294-90-332 1006-653 1982-1009 3062 521 140 1139 313 1761 471 1277 324 2559 629 3834 964 881 231 1062 586 785 1438-966 2971-4714 5643-7912 5642-832 0-1154-327-1102-1161 106-1695 227-3390 338-5084 14-226 2-455 2-650h-3235c0 197-13 445 2 690 107 1695 227 3390 327 5085 49 802-257 1109-1065 1120-3145 44-6961-2658-7932-5616-292-887-108-1241 817-1478 1866-479 3736-939 5570-1399-346-1046-674-2040-1026-3107-1300 509-2650 1038-4000 1567-437 172-873 350-1311 519-946 365-1319 178-1593-812-561-2026-217-3967 598-5854 536-1241 1308-2313 2406-3135 742-555 1184-480 1684 292 887 1373 1762 2753 2645 4129 149 233 308 460 446 666 877-636 1716-1242 2625-1900-98-130-238-331-395-517-1081-1290-2171-2574-3249-3868-599-721-533-1121 242-1663 2567-1794 7080-1798 9646-9 797 556 853 952 212 1719-1212 1451-2433 2894-3637 4325z"
      style={{
        fill: "#000",
        stroke: "#fefefe",
        strokeWidth: 271.307,
      }}
      className="fill stroke1"
    />
  </svg>
)
export default SvgComponent
